import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { environment } from '@environments/environment';
import { catchError, of } from 'rxjs';
import { ITeamEquipment } from '../models';

@Injectable({
  providedIn: 'root',
})
export class TeamEquipmentService {
  private http = inject(HttpClient);
  private env = environment;
  private headers = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  isLoadingTeamEquipment = signal<boolean>(false);
  isErrorTeamEquipment = signal<boolean>(false);
  teamEquipment = signal<ITeamEquipment | null>(null);

  constructor() {}

  getTeamEquipment(
    teamId: string,
    callback?: () => void,
    isRefreshing: boolean = false
  ) {
    if (!isRefreshing) this.isLoadingTeamEquipment.set(true);
    this.isErrorTeamEquipment.set(false);

    this.http
      .get<ITeamEquipment | null>(
        `${this.env.baseUrlWeb}/teams/${teamId}/info`,
        {
          headers: this.headers,
        }
      )
      .pipe(
        catchError((_) => {
          this.isLoadingTeamEquipment.set(false);
          this.isErrorTeamEquipment.set(true);

          return of(null);
        })
      )
      .subscribe((data) => {
        if (!data) {
          this.teamEquipment.set(null);
          this.isLoadingTeamEquipment.set(false);
          return;
        }

        this.teamEquipment.set(data);
        callback && callback();
        this.isLoadingTeamEquipment.set(false);
      });
  }
}
